/** React */
import { Link } from "react-router";

/** Images */
import { ReactComponent as Logo } from "../../assets/logo.svg";

/** MUI */
import {
    Box,
    Container,
    Stack,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

/** Components */
import classes from "./footer.module.css";

const Footer = () => {
    return (
        <Box className={classes.backgroundFoot}>
            <Container maxWidth="xl" disableGutters className={classes.containerSpacing}>
                <Grid container spacing={2} justifyContent="space-between">
                    <Grid size={{ xs: 12, sm: 3, lg: 2 }}>
                        <Logo className={classes.logo} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3, lg: 2 }}>
                        <Typography variant="h3" color="secondary" pb={2}>
                            Product
                        </Typography>
                        <Stack spacing={2}>
                            <Link to="/" className={classes.links}>
                                Home
                            </Link>
                            <Link to="/terms-and-conditions" className={classes.links}>
                                Terms and Conditions
                            </Link>
                            <Link to="/privacy-policy" className={classes.links}>
                                Privacy Policy
                            </Link>
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
            <Container maxWidth="xl" disableGutters className={classes.containerSpacing2}>
                <Typography className={classes.rights}>© {new Date().getFullYear()} Noddok. All Rights Reserved.</Typography>
            </Container>
        </Box>
    );
};

export default Footer;